import { z } from 'zod';
/**
 * Delete OrgFunction Request Schema
 * DELETE /api/v2/orgFunction/:id
 */ export const DeleteOrgFunctionRequestSchema = z.object({});
/**
 * Delete OrgFunction Response Schema
 * DELETE /api/v2/orgFunction/:id
 */ export const DeleteOrgFunctionResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-org-function.schema.js.map